import React, { Component, createRef } from "react";
import { resetPassword } from "./action";
import { translate } from "../base/i18n";
import { isEmpty } from "../../utilities/validation";
import { Watermarks } from '../base/react';

class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newPassword: "",
            confirmPassword: "",
            isFormSubmitted: false,
            formErrors: {
                newPassword: "",
                confirmPassword: "",
            },
            newPasswordChecked: false,
            confirmPasswordChecked: false,
            newPasswordType: "password",
            confirmPasswordType: "password"
        }
        this.onChange = this.onChange.bind(this);
        this.onSubmitClick = this.onSubmitClick.bind(this);
        this.isAllFieldsValid = this.isAllFieldsValid.bind(this);
        this.validateField = this.validateField.bind(this);
        this.onNewPasswordEyeButtonClick = this.onNewPasswordEyeButtonClick.bind(this);
        this.onConfirmPasswordEyeButtonClick = this.onConfirmPasswordEyeButtonClick.bind(this);

        this.newPasswordRef = createRef();
        this.confirmPasswordRef = createRef();
    }
    isAllFieldsValid() {
        let formErrors = this.state.formErrors;
        let isAllValid = true;
        for (let fieldName in formErrors) {
            this.validateField(fieldName, this.state[fieldName]);
            if (formErrors[fieldName].length > 0) {
                isAllValid = false;
            }
        }
        return isAllValid;
    }
    validateField(fieldName, fieldValue) {
        const { t } = this.props;
        let formErrors = this.state.formErrors;
        switch (fieldName) {
            case "confirmPassword":
                formErrors.confirmPassword = isEmpty(fieldValue)
                    ? t("loginPage.passwordEmpty")
                    : "";
                break;
            case "newPassword":
                formErrors.newPassword = isEmpty(fieldValue)
                    ? t("loginPage.passwordEmpty")
                    : "";
                break;
        }
        this.setState({ formErrors });
    }

    onSubmitClick() {
        this.setState({ isFormSubmitted: true });
        if (!this.isAllFieldsValid()) {
            return;
        };
        let url = window.location.href;
        let urlParams = url.split("/");
        let requestBody = {};
        requestBody.userid = urlParams[urlParams.length - 1];
        requestBody.uuid = urlParams[urlParams.length - 2];
        requestBody.password = this.state.newPassword;
        requestBody.retypepwd = this.state.confirmPassword;

        resetPassword(requestBody);

    }
    onChange(event) {
        let name = event.target.name;
        let value = event.target.value;

        if (name === "newPasswordChecked" || name === "confirmPasswordChecked") {
            value = event.target.checked;
        }
        this.setState({ [name]: value }, () => {
            if (this.state.isFormSubmitted) {
                this.validateField(name, value);
            }
        });
    }
    onNewPasswordEyeButtonClick() {

        let inputType = this.newPasswordRef.current.type;
        if (inputType === "password") {
            this.setState({ newPasswordType: "text" })
        } else {
            this.setState({ newPasswordType: "password" })
        }
    }
    onConfirmPasswordEyeButtonClick() {
        let inputType = this.confirmPasswordRef.current.type;
        if (inputType === "password") {
            this.setState({ confirmPasswordType: "text" })
        } else {
            this.setState({ confirmPasswordType: "password" })
        }

    }
    render() {
        return (
            <div className="reset_pass">
                <div className="d_table">
                    <div className="t_cell">
                        <div className="logo_img">
                            <img src={interfaceConfig.DEFAULT_LOGO_URL} alt="Logo" />
                        </div>
                        <h2 className="">Reset Password</h2>
                        <div className="form-group">
                            <label>Enter New Password:</label>
                            <div className="show_password">
                                <div className="button-outer">
                                    <label className="switch">
                                        <input checked={this.state.newPasswordChecked}
                                            type="checkbox"
                                            name="newPasswordChecked"
                                            value={this.state.newPasswordChecked}
                                            onChange={this.onChange}
                                            onClick={this.onNewPasswordEyeButtonClick}
                                        />
                                        <span className="slider round"></span>
                                        <span className="button-title"></span>
                                    </label>
                                </div>
                                <input
                                    type={this.state.newPasswordType}
                                    className="form-control"
                                    name="newPassword"
                                    value={this.state.newPassword}
                                    onChange={this.onChange}
                                    ref={this.newPasswordRef} />
                            </div>
                            {this.state.isFormSubmitted &&
                                this.state.formErrors.newPassword &&
                                <span className="error">
                                    {this.state.formErrors.newPassword}
                                </span>}
                        </div>
                        <div className='form-group'>
                            <label>Enter Confirm Password:</label>
                            <div className="show_password">
                                <div className="button-outer">
                                    <label className="switch">
                                        <input checked={this.state.confirmPasswordChecked}
                                            type="checkbox"
                                            name="confirmPasswordChecked"
                                            value={this.state.confirmPasswordChecked}
                                            onChange={this.onChange}
                                            onClick={this.onConfirmPasswordEyeButtonClick}
                                        />
                                        <span className="slider round"></span>
                                        <span className="button-title"></span>
                                    </label>
                                </div>
                                <input
                                    type={this.state.confirmPasswordType}
                                    className="form-control"
                                    name="confirmPassword"
                                    value={this.state.confirmPassword}
                                    onChange={this.onChange}
                                    ref={this.confirmPasswordRef} />
                            </div>
                            {this.state.isFormSubmitted &&
                                this.state.formErrors.confirmPassword &&
                                <span className="error">
                                    {this.state.formErrors.confirmPassword}
                                </span>}
                        </div>
                        <div>
                            <button className="btn btn-info" onClick={this.onSubmitClick}>Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default translate(ResetPassword);
